angular.module("auth")
    .controller('AuthRegisterYubicoOTPCtrl', ['$translate', '$scope', 'LoginService', '$rootScope', '$uibModal', '$http', '$state', 'modalService', 'Restangular', '$stateParams', '$location', '$httpParamSerializer', '$timeout', 'logService', function ($translate, $scope, LoginService, $rootScope, $uibModal, $http, $state, modalService, Restangular, $stateParams, $location, $httpParamSerializer, $timeout, logService) {
        $scope.userToken = $stateParams.token;
        $scope.code = '';
        $rootScope.loginProcess = false;
        $scope.registerYubicoOTP = function () {
            if ($scope.code.length >= 12) {
                $http.post((window as any).CONFIG.api_url + '/Auth/YubicoOTP/Register/' + $scope.code.substring(0, 12) + '/' + $scope.userToken)
                    .then(function (result) {
                    if (result.data.success) {
                        $state.go('authinit');
                    }
                });
            }
        }
    }]);